module.exports = __webpack_public_path__ + "static/img/cover18.d7208b4f.jpg";